<template>
  <div class="template">
    <AmendmentsZoomParams />
    <LoaderFullPage v-if="store.loading" />
    <AmendmentsZoomDatas v-else />
  </div>
</template>

<script setup>
import { watch } from "vue";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import { FOLLAWED_FEATURES, useUserStore } from "@follaw-fr/stores/user";
import {
  demandeSuiviDepuisMail,
  retirerParametreSuivi,
} from "@follaw-fr/utils/follaw-depuis-mail";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import AmendmentsZoomParams from "@follaw-fr/components/amendments/organisms/AmendmentsZoomParams.vue";
import AmendmentsZoomDatas from "@follaw-fr/components/amendments/organisms/AmendmentsZoomDatas.vue";
import { useAmendmentsStore } from "@/follaw-fr/stores/amendments";

const store = useAmendmentsStore();
const route = useRoute();
const router = useRouter();
const toast = useToast();
const userStore = useUserStore();
const { isTopbarReady } = storeToRefs(userStore);

const chargement = store.fetchOneAmendment(route.params.id);

function topbarPrete() {
  return new Promise((resolve) => {
    if (isTopbarReady.value) return resolve();
    const stop = watch(isTopbarReady, (pret) => {
      if (pret) {
        stop();
        resolve();
      }
    });
  });
}

// Lien « Follaw » du mail d'alerte : `?follaw=1`. On attend que l'amendement soit chargé (un identifiant invalide ne se
// suit pas) et que la liste des éléments suivis de l'utilisateur soit chargée (sinon on l'écraserait). On AJOUTE sans
// jamais retirer, on ne confirme qu'après la réponse du serveur, puis on nettoie l'adresse.
async function suivreDepuisLeMail() {
  const id = String(route.params.id);
  const [amendement] = await Promise.all([
    chargement.catch(() => null),
    topbarPrete(),
  ]);

  if (amendement?._id !== id) {
    toast.error("Amendement introuvable : il n'a pas pu être suivi.");
  } else {
    const resultat = await userStore.addFollawed(
      FOLLAWED_FEATURES.AMENDMENTS,
      id
    );
    if (resultat === "ajoute") toast.success("Vous suivez cet amendement.");
    else if (resultat === "deja_suivi")
      toast.info("Vous suivez déjà cet amendement.");
    else
      toast.error(
        "Impossible de suivre cet amendement pour le moment. Réessayez avec l'étoile de la page."
      );
  }
  router.replace({ query: retirerParametreSuivi(route.query) });
}

if (demandeSuiviDepuisMail(route.query)) {
  suivreDepuisLeMail();
}
</script>
